import { Component, OnInit, ContentChild, ElementRef, ViewContainerRef, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpErrorResponse} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { DtoService } from '../../services/dto.service';
import { UtilService } from '../../services/util.service';
import { FunctService } from '../../services/funct.service';
import { CommonService } from '../../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-phone-picker',
  templateUrl: './app-phone-picker.component.html',
  styleUrls: ['./app-phone-picker.component.scss']
})

@Injectable({
  providedIn: 'root'
})

export class AppPhonePickerComponent implements OnInit {

  @Input() prefix = "+95";
  @Input() phoneValue = ""; 
  @Input() regularExpressionPhone = '';
  @Input() isDisabled = false;

  @Output() phoneValueChange = new EventEmitter<string>();
  @Output() regularExpressionPhoneChange = new EventEmitter<string>();
  @Output() prefixChange = new EventEmitter<string>();

  // supportLanguages = ['en', 'my', 'th', 'zh', 'my_zawgyi'];
  phone_no: any;  
  regExpressionList :any;   
  registerCountryCode: any;  
  CountryCodeActive: any;
  selectedIndex: any;
  imageUrl: any ;//"assets/img/common/myan-lan.png";
  localRegisterCountryCode: any;
  regularExpression: any = "^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$";
  activeLang: any;
  previousPhoneValue: any;
  currentPhoneValue: any;
  constructor(
    private translateService: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dto: DtoService,
    private http: HttpClient,
    private util: UtilService, 
    private router: Router,
    private storage: LocalStorageService,
    private funct: FunctService,
    private common: CommonService) {
  }

  ngOnInit(): void {

    this.prefix = "+95";
    if(this.storage.retrieve('localPhonePrefix') == null){
      this.storage.store('localPhonePrefix', this.prefix);
    }

    this.phoneValue = this.storage.retrieve('localPhoneValue');//Here remove comment again for text field phone value
    if (this.phoneValue) {
      this.previousPhoneValue = this.phoneValue;
      this.storage.store("prevPhone",this.previousPhoneValue);
      this.phoneValue = this.phoneValue;
      this.currentPhoneValue = this.phoneValue;
    }
    this.getRegisterCountryCode();

    this.selectedIndex = 0;

    if (this.registerCountryCode !=null) {
      if (this.registerCountryCode.length > 0) {
        this.prefix = this.registerCountryCode[this.selectedIndex].prefix;
        this.imageUrl = this.registerCountryCode[this.selectedIndex].imageUrl;
        this.regularExpression = this.registerCountryCode[this.selectedIndex].regularExpression;
      }
    }
      
  }

  handleError(error: HttpErrorResponse){
   
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
      return;

    } else if(error.status == 423) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
      return;

    } else if(error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;
      
    }

    return throwError(error);
  }

  changeRegisterCountryCode(){
    this.prefix=this.registerCountryCode[this.selectedIndex].prefix;
    this.imageUrl = this.registerCountryCode[this.selectedIndex].imageUrl;
    this.regularExpression = this.registerCountryCode[this.selectedIndex].regularExpression;    
    this.regularExpressionPhoneChange.emit(this.regularExpression);
    this.prefixChange.emit(this.prefix);
    this.phoneValueChange.emit(this.phoneValue);
    this.storage.store('localPhonePrefix',this.prefix);
  }

  selectedRegisterCountryCode(index: number, dropdown) {
    this.selectedIndex = index;
    this.changeRegisterCountryCode();
    //dropdown.isOpen = false;
    dropdown.hide();   // ✅ IMPORTANT
  }

  getRegisterCountryCodeBak() {

    let headers = new HttpHeaders();

    this.registerCountryCode = [];
    this.registerCountryCode = this.storage.retrieve('localRegisterCountryCode');
    
    if (this.registerCountryCode != null) {
      this.registerCountryCode = this.storage.retrieve('localRegisterCountryCode');
    }

    this.http.get(this.funct.ipaddress + 'registerPhone/getRegisterPhoneMobileList', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        this.registerCountryCode = this.dto.Response;
        let _prefix=this.storage.retrieve('localPhonePrefix');    
        this.registerCountryCode.forEach(element => {
          if(element.prefix == _prefix){
            this.prefix=element.prefix;
            this.imageUrl=element.imageUrl;
          }           
        });  
        this.storage.store('localRegisterCountryCode',  this.registerCountryCode);
      }
    );
  }

  getRegisterCountryCode() {
    let headers = new HttpHeaders();
  
    this.http.get(this.funct.ipaddress + 'registerPhone/getRegisterPhoneMobileList', { headers })
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe((result: any[]) => {
  
        this.registerCountryCode = result;
  
        const savedPrefix = this.storage.retrieve('localPhonePrefix');
  
        if (savedPrefix) {
          const index = this.registerCountryCode.findIndex(
            x => x.prefix === savedPrefix
          );
  
          this.selectedIndex = index !== -1 ? index : 0;
        } else {
          this.selectedIndex = 0;
        }
  
        // ✅ apply selected country
        this.changeRegisterCountryCode();
  
        // cache list
        this.storage.store('localRegisterCountryCode', this.registerCountryCode);
      });
  }
  
  checkPhoneNumber() {
    $("#phone-error").html("");
    $("#phone-input-group").removeClass('error');
    $(".auth-valid").removeAttr("style");
    this.phoneValueChange.emit(this.phoneValue);
    this.storage.store('localPhoneValue', this.phoneValue);

    if (this.phoneValue != null && this.phoneValue.length == 0) {
      var phoneRequired = this.translateService.instant("requiredFiled");
      phoneRequired =  phoneRequired.toString().replace("@value", this.translateService.instant("phoneNumberHint"));
      //phoneRequired =  phoneRequired.toString().replace("@value", this.prefix);//Add this #Test
      $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneRequired}</span>`);
      $("#phone-input-group").addClass('error');
      $(".auth-valid").css("display", "none");
      return false;
    }

    if (this.prefix !== '+86' && this.prefix !== '+60') {
      if (!this.phoneValue.startsWith('0')) {
        var phoneInvaild = this.translateService.instant("phoneInvaild");
        $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
        $("#phone-input-group").addClass('error');
        $(".auth-valid").css("display", "none");
        return false;
      }
      if (this.phoneValue.startsWith('00')) { //added this section #Test
        var phoneInvaild = this.translateService.instant("phoneInvaild");
        $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
        $("#phone-input-group").addClass('error');
        $(".auth-valid").css("display", "none");
        return false;
      }
    }
    
    if(this.prefix !== '+60')
    {
      let pattern = RegExp(this.regularExpressionPhone, 'g'); // /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/;phoneInvaild
      if (!pattern.test(this.phoneValue)) {
        var phoneInvaild = this.translateService.instant("phoneInvaild")
        $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
        $("#phone-input-group").addClass('error');
        $(".auth-valid").css("display", "none");
        return false;
      }
    }
    // if(this.prefix === '+60')
    // {
    //   if(this.phoneValue.startsWith("0"))
    //   {
    //     var phoneInvaild = this.translateService.instant("phoneInvaild")
    //     $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
    //     $("#phone-input-group").addClass('error');
    //     $(".auth-valid").css("display", "none");
    //     return false;
    //   }
    //   else
    // {
    //   let pattern = RegExp("^(\\+\\d{1,3}\\s?)?[(]?\\d{3}[)]?[-.\\s]?\\d{3}[-.\\s]?\\d{3,6}$", 'g');
    //   if (!pattern.test(this.phoneValue)) {
    //     var phoneInvaild = this.translateService.instant("phoneInvaild")
    //     $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
    //     $("#phone-input-group").addClass('error');
    //     $(".auth-valid").css("display", "none");
    //     return false;
    //   }
    // }
    // }
    if(this.prefix === '+60')
    {
      if(!this.phoneValue.startsWith("0"))
      {
        var phoneInvaild = this.translateService.instant("phoneInvaild")
        $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
        $("#phone-input-group").addClass('error');
        $(".auth-valid").css("display", "none");
        return false;
      }
      //let pattern = new RegExp('^01\\d{9,12}$');   
      let pattern = new RegExp('^01\\d{8,9}$');
      if (!pattern.test(this.phoneValue))
      {
        var phoneInvaild = this.translateService.instant("phoneInvaild")
        $("#phone-error").html(`<img src="assets/img/common/incorrect.png" alt="" width="20px"><span style="position: relative; top: -5px;">&nbsp;${phoneInvaild}</span>`);
        $("#phone-input-group").addClass('error');
        $(".auth-valid").css("display", "none");
        return false;
      }
     }
    $("#phone-error").html("");
    $("#phone-input-group").removeClass("error");
    $(".auth-valid").removeAttr("style");
    return true;
  }

  enter(event) {
    event.target.blur();
  }

  space(event) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) {
      return false;
    }
  }

 
}
